export function isJWT(str) {
    return str.split(".").length === 3;
}
//# sourceMappingURL=is-jwt.js.map